package com.eladfinish.bible.contest.di.shake

import com.eladfinish.bible.contest.platform.shake.ShakeController
import com.eladfinish.bible.contest.platform.shake.WebShakeController
import org.koin.core.module.Module
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

internal actual val shakePlatformModule: Module = module {
    singleOf(::WebShakeController)
    single<ShakeController> { get<WebShakeController>() }
}
